import React from "react";
import { useLocation } from "react-router-dom";
import { ThemeProvider } from "@mui/material/styles";
import { motion, MotionConfig, useReducedMotion } from "motion/react";
import { schedulingTheme } from "./SchedulingTheme";

export default function SchedulingShell({ children }) {
  const location = useLocation();
  const reduced = useReducedMotion();
  return <ThemeProvider theme={schedulingTheme}><MotionConfig reducedMotion="user">
    <div className="scheduling-ui">
      <motion.div key={location.pathname} initial={reduced ? false : { opacity: 0, y: 6 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: .18, ease: "easeOut" }}>
        {children}
      </motion.div>
    </div>
  </MotionConfig></ThemeProvider>;
}
